import SkeletonDiv from "../../../general/loading/SkeletonDiv";


const Linked = ({header, links, loading, toComponent}) => {

    const Loading = () => {
        return (
            <>
                {[...Array(4).keys()].map((e,i) =>
                    <div className="tile" style={{padding: "4pt 8pt", marginBottom: "10pt"}}>
                        <SkeletonDiv style={{height: "20pt", width: "80%"}}/>
                    </div>
                )}
            </>
        )
    }

    const getDisplay = () => {
        if(loading) {
            return <Loading/>
        } else if(!links || links.length === 0) {
            return <p>None linked to this order</p>
        } else {
            return (
                <div className="tile">
                    {links.map((e,i) => toComponent(e,i))}
                </div>
            )
        }
    }


    return (
        <>
            <p className="account-header-2">{header}</p>
            {getDisplay()}
        </>
    )
}

export default Linked;